import React, { useState } from "react";
import Modal from "../components/Modal";
import { Button, Field, Input, Select } from "../components/ui";
import { useCreateClub, useUpdateClub } from "../apiCalls/clubApiCalls";
import { getData } from "country-list";

// The API stores an ISO 3166-1 alpha-2 code, the same as Player.nationality,
// so offer the country list rather than a free-text field.
const COUNTRIES = getData();

export default function ClubForm({ club, onClose }) {
  const isEdit = Boolean(club);

  const [form, setForm] = useState(() => ({
    name: club?.name || "",
    country: club?.country || "",
    city: club?.city || "",
    address: club?.address || "",
    isActive: club ? String(club.isActive) : "true",
  }));

  const { mutate: create, isLoading: isCreating } = useCreateClub();
  const { mutate: update, isLoading: isUpdating } = useUpdateClub();
  const isSaving = isCreating || isUpdating;

  const set = (field) => (event) =>
    setForm((current) => ({ ...current, [field]: event.target.value }));

  const handleSubmit = (event) => {
    event.preventDefault();
    const payload = { ...form, isActive: form.isActive === "true" };
    const onSuccess = () => onClose();

    if (isEdit) update({ id: club._id, ...payload }, { onSuccess });
    else create(payload, { onSuccess });
  };

  return (
    <Modal
      title={isEdit ? `Edit ${club.name}` : "Add a club"}
      onClose={onClose}
      footer={
        <>
          <Button onClick={onClose}>Cancel</Button>
          <Button
            type="submit"
            form="club-form"
            variant="primary"
            disabled={isSaving}
          >
            {isSaving ? "Saving" : isEdit ? "Save changes" : "Add club"}
          </Button>
        </>
      }
    >
      <form
        id="club-form"
        onSubmit={handleSubmit}
        className="grid gap-5 sm:grid-cols-2"
      >
        <div className="sm:col-span-2">
          <Field label="Club name">
            <Input value={form.name} onChange={set("name")} required autoFocus />
          </Field>
        </div>

        <Field label="Country">
          <Select value={form.country} onChange={set("country")} required>
            <option value="">Select a country</option>
            {COUNTRIES.map((country) => (
              <option key={country.code} value={country.code}>
                {country.name}
              </option>
            ))}
          </Select>
        </Field>

        <Field label="City">
          <Input value={form.city} onChange={set("city")} />
        </Field>

        <Field
          label="Listing"
          hint="Retired clubs stay in the data but disappear from the public site."
        >
          <Select value={form.isActive} onChange={set("isActive")}>
            <option value="true">Listed</option>
            <option value="false">Retired</option>
          </Select>
        </Field>

        <div className="sm:col-span-2">
          <Field label="Address">
            <Input value={form.address} onChange={set("address")} />
          </Field>
        </div>
      </form>
    </Modal>
  );
}
